var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5424 4.25699C10.7593 4.04003 10.7593 3.68827 10.5424 3.47132C10.3254 3.25436 9.97366 3.25436 9.75671 3.47132L7.00724 6.22078L4.25699 3.47131C4.04003 3.25435 3.68827 3.25435 3.47131 3.47131C3.25436 3.68827 3.25436 4.04003 3.47131 4.25699L6.22156 7.00646L3.47131 9.75671C3.25435 9.97367 3.25435 10.3254 3.47131 10.5424C3.68827 10.7593 4.04003 10.7593 4.25699 10.5424L7.00724 7.79213L9.75671 10.5424C9.97367 10.7593 10.3254 10.7593 10.5424 10.5424C10.7593 10.3254 10.7593 9.97366 10.5424 9.75671L7.79291 7.00646L10.5424 4.25699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.5b228bd2bb9d5bb2541d1f1a5c101f17.svg";
export { ForwardRef as ReactComponent };